import './AccessEmptyState.css';

export function AccessEmptyState() {
  return (
    <div className="access-empty-state" role="status">
      <p className="access-empty-state__message">
        Нет доступа к разделам. Обратитесь к администратору.
      </p>
    </div>
  );
}
